var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "grid-container pivot-table-container" },
    [
      _c(
        "ejs-pivotview",
        _vm._b(
          { ref: "pivotview", attrs: { id: "pivotview" } },
          "ejs-pivotview",
          _vm.gridProps,
          false
        )
      ),
      _c("save-dialog", {
        attrs: {
          report: _vm.dataSourceSettings,
          showDialog: _vm.showDialog,
          title: _vm.dialogHeader,
          rename: _vm.doRename,
        },
        on: {
          closeDialog: _vm.closeDialog,
          renameDialog: _vm.renameReport,
          saveDialog: _vm.saveReport,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }